import { AuthCodeBaseData } from '@zero/shared/util-web-app-services';

export class ServerAuthcodeData extends AuthCodeBaseData {
  public authCode: string;

  constructor(type: string, code: string) {
    super(type);
    this.authCode = code;
  }
}
